export interface InputTool {
    id: string;
    label: string;           // Display name in menu (e.g., "Web Search")
    activeLabel: string;     // Display name when active (e.g., "Search")
    icon: string;            // Font Awesome icon class (e.g., "globe")
    parameterKey: string;    // Links to parameter in parameters.tsx (e.g., "webSearch")
}

export const inputTools: InputTool[] = [
    {
        id: 'web-search',
        label: 'Web Search',
        activeLabel: 'Search',
        icon: 'globe',
        parameterKey: 'webSearch'
    }
    // Future tools can be added here
];
